import type { Wallet } from './types'
export const PLAN_KINDS = {
  single_project: 'single_project',
  subscription: 'subscription',
  legacy_subscription: 'legacy_subscription',
  demo: 'demo',
  trial: 'trial',
} as const

export const TRIAL_PAGE_GRANT = 50
export const TRIAL_LENGTH_DAYS = 14
export const TRIAL_MAX_FILE_PAGES = 500
// Mirrors lukita's trial price grant and Account::TRIAL_UPLOAD_CAP.
export const TRIAL_PAGE_ALLOWANCE = 50
export const TRIAL_UPLOAD_CAP = 500

export const WALLET_TITLES: Record<Wallet, string> = {
  pages: 'Page credits',
  screenings: 'Screenings credits',
}
